import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/query/react';
import { DanaosTaskResponse } from '@state/stores/danaos/DanaosTaskResponse';

export const danaosApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: 'secured/danaos' }),
  tagTypes: ['DANAOS_PROTOCOL', 'DANAOS_TASK'],
  reducerPath: 'danaos-api',
  endpoints: (build) => ({
    sendProtocolEvent: build.mutation<
      { success: boolean; message?: string },
      { evaluationId: number }
    >({
      query: ({ evaluationId }) => ({
        url: '/protocol',
        method: 'POST',
        data: { evaluationId }
      }),
      invalidatesTags: (res, _err, { evaluationId }) =>
        res
          ? [{ type: 'DANAOS_PROTOCOL', id: evaluationId }]
          : ['DANAOS_PROTOCOL']
    }),

    // Task status endpoints
    getTask: build.query<
      DanaosTaskResponse,
      { entityType: string; id: number; buyerId: number }
    >({
      query: ({ entityType, id, buyerId }) => ({
        url: `/task/${entityType}/${id}?buyerId=${buyerId}`,
        method: 'GET'
      }),
      providesTags: (result, _error, { entityType, id }) =>
        result
          ? [{ type: 'DANAOS_TASK', id: `${entityType}-${id}` }]
          : ['DANAOS_TASK']
    }),

    getTaskDetails: build.query<
      DanaosTaskResponse,
      { entityType: string; id: number; buyerId: number }
    >({
      query: ({ entityType, id, buyerId }) => ({
        url: `/task-details/${entityType}/${id}?buyerId=${buyerId}`,
        method: 'GET'
      }),
      providesTags: (result, _error, { entityType, id }) =>
        result
          ? [{ type: 'DANAOS_TASK', id: `${entityType}-${id}` }]
          : ['DANAOS_TASK']
    }),

    getAvailableFlows: build.query<string[], void>({
      query: () => ({
        url: '/flows',
        method: 'GET'
      })
    })
  })
});

export type StateWithDanaosApi = {
  [danaosApi.reducerPath]: ReturnType<typeof danaosApi.reducer>;
};

export const {
  useSendProtocolEventMutation,
  useGetTaskQuery,
  useGetTaskDetailsQuery,
  useGetAvailableFlowsQuery
} = danaosApi;
